import React from "react";
import {Helmet} from "react-helmet";
import { multiSitePages } from ".";
import {siteData} from './locationsData'

export default class Base extends React.Component {
  

  render () {
    // console.log('hi', shop)
    let name = siteData.name || ""
    let description = siteData.description || ""
    let domain = "https://" + siteData.domain
    const base = siteData.iconRoot;
    const icons = [
      { rel: 'icon', size: 16 },
      { rel: 'icon', size: 32 },
      { rel: 'apple-touch-icon', size: 180 },
      { rel: 'icon', size: 192 },
      { rel: 'icon', size: 512 },
    ];

    const png = (size) => `${base}?w=${size}&fm=png&auto=compress`;

    const jsonLd = siteNavJsonLd(domain, multiSitePages);
    return (
      <Helmet>
          <meta charSet="utf-8" />
          <title>{name}</title>
          <meta name="description"
            content={description} />
          <link rel="canonical" href={domain} />

          <link rel="manifest" href={`${process.env.PUBLIC_URL}/${siteData.folderId}.json`} />
          <meta name="theme-color" content="#ffffff" />
          
          {/* Favicon set */}
          {icons.map((i) => (
            <link
              key={i.size}
              rel={i.rel}
              type="image/png"
              sizes={`${i.size}x${i.size}`}
              href={png(i.size)}
            />
          ))}

          {/* Legacy ICO fallback */}
          <link rel="shortcut icon" href={`${base}?fm=png&w=32`} />    


          {/* Open Graph */}
          <meta property="og:title" content={name} />
          <meta property="og:site_name" content={name} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={siteData.ogImage} />

          <script type="application/ld+json">{jsonLd}</script>

          {/* <meta property="og:image" content={} /> */}
          {/* <meta property="og:url" content="http://euro-travel-example.com/index.htm" /> */}
      </Helmet>


    );
  }
};

// export default injectShopContainer(Base)


const siteNavJsonLd = (baseUrl, pages = []) => {
  if (!baseUrl) {
    return "";
  }

  const normalizePath = (p) =>
    "/" + String(p || "/").replace(/^\/*/, "").replace(/\/+$/, "");
  const seen = new Set();

  const elements = pages
    .filter((p) => p && p.path && p.label)
    .map((p) => {
      const path = normalizePath(p.path);
      const key = `${p.label}|${path}`;
      if (seen.has(key)) return null;
      seen.add(key);
      return {
        "@type": "SiteNavigationElement",
        name: p.label,
        url: new URL(path, baseUrl).toString(),
      };
    })
    .filter(Boolean);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: elements.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      item,
    })),
  };

  return JSON.stringify(jsonLd, null, 2);
};
